import { SymbolTypeEnum } from "../enums/SymbolType.enum";

export interface IQuotaData {
    S: string;
    B: any;
    A: any;
    D:number;
}

interface IPips {
    symbol: string;
    fix: number;
    precision: number;
}



export const pipValues:IPips[]=
[
    { symbol:"UK 100", fix:	0.1, precision:1},
    { symbol:"AUD/CAD", fix:0.0001, precision:4},
    { symbol:"AUD/JPY", fix:0.01	, precision:4},
    { symbol:"AUD/NZD", fix:0.0001, precision:4},
    { symbol:"AUD/USD", fix:0.0001, precision:4},
    { symbol:"CAD/JPY", fix:0.01	, precision:4},
    { symbol:"CHF/JPY", fix:0.01	, precision:4},
    { symbol:"EUR/AUD", fix:0.0001, precision:4},
    { symbol:"EUR/CAD", fix:0.0001, precision:4},
    { symbol:"EUR/CHF", fix:0.0001, precision:4},
    { symbol:"EUR/GBP", fix:0.0001, precision:4},
    { symbol:"EUR/JPY", fix:0.01	, precision:4},
    { symbol:"EUR/USD", fix:0.0001, precision:4},
    { symbol:"GBP/CHF", fix:0.0001, precision:4},
    { symbol:"GBP/JPY", fix:0.01	, precision:4},
    { symbol:"GBP/USD", fix:0.0001, precision:4},
    { symbol:"NZD/JPY", fix:0.01	, precision:4},
    { symbol:"NZD/USD", fix:0.0001, precision:4},
    { symbol:"USD/CAD", fix:0.0001, precision:4},
    { symbol:"USD/CHF", fix:0.0001, precision:4},
    { symbol:"USD/HKD", fix:0.0001, precision:4},
    { symbol:"USD/JPY", fix:0.01	, precision:4},
    { symbol:"ZAM/JPY", fix:0.01	, precision:4}
    
];

interface IType
{
    symbol:string;
     type:SymbolTypeEnum
}


export const symbolTypes:IType[] = 
[
    { symbol:"UK 100", type: SymbolTypeEnum.Forex},
    { symbol:"AUD/CAD", type: SymbolTypeEnum.Forex},
    { symbol:"AUD/JPY", type: SymbolTypeEnum.Forex},
    { symbol:"AUD/NZD", type: SymbolTypeEnum.Forex},
    { symbol:"AUD/USD", type: SymbolTypeEnum.Forex},
    { symbol:"CAD/JPY", type: SymbolTypeEnum.Forex},
    { symbol:"CHF/JPY", type: SymbolTypeEnum.Forex},
    { symbol:"EUR/AUD", type: SymbolTypeEnum.Forex},
    { symbol:"EUR/CAD", type: SymbolTypeEnum.Forex},
    { symbol:"EUR/CHF", type: SymbolTypeEnum.Forex},
    { symbol:"EUR/GBP", type: SymbolTypeEnum.Forex},
    { symbol:"EUR/JPY", type: SymbolTypeEnum.Forex},
    { symbol:"EUR/USD", type: SymbolTypeEnum.Forex},
    { symbol:"GBP/CHF", type: SymbolTypeEnum.Forex},
    { symbol:"GBP/JPY", type: SymbolTypeEnum.Forex},
    { symbol:"GBP/USD", type: SymbolTypeEnum.Forex},
    { symbol:"NZD/JPY", type: SymbolTypeEnum.Forex},
    { symbol:"NZD/USD", type: SymbolTypeEnum.Forex},
    { symbol:"USD/CAD", type: SymbolTypeEnum.Forex},
    { symbol:"USD/CHF", type: SymbolTypeEnum.Forex},
    { symbol:"USD/HKD", type: SymbolTypeEnum.Forex},
    { symbol:"USD/JPY", type: SymbolTypeEnum.Forex},
    { symbol:"ZAM/JPY", type: SymbolTypeEnum.Forex}
];

    export const monitorInitialList:string[] =
    [
        "AUD/CAD",
        "AUD/JPY",
        "AUD/NZD",
        "AUD/USD",
        "CAD/JPY",
        "CHF/JPY",
        "EUR/AUD",
        "EUR/CAD",
        "EUR/CHF",
        "EUR/GBP",
        "EUR/JPY",
        "EUR/USD",
        "GBP/CHF",
        "GBP/JPY",
        "GBP/USD",
        "NZD/JPY",
        "NZD/USD",
        "USD/CAD",
        "USD/CHF",
        "USD/JPY"
    ];








export function getTypeBySymbol(symbol:string): SymbolTypeEnum {
    let p:IType[] = symbolTypes.filter(x=>x.symbol===symbol);
    if(p.length>0) { return p[0].type; }
    return SymbolTypeEnum.Crypto;
}

export function getPipBySymbol(symbol:string): number {

    /*temp*/
    return 0.1;
    let p:IPips[] = pipValues.filter(x=>x.symbol===symbol);
    
    if(p.length>0) { 
        console.log([symbol,p[0].fix/10]);
        return p[0].fix/10;
     }

    return 0.1;
}

export function numberToFixedPrecision(num:Number,precision:number): number
{
    return Number(Number(num).toFixed(precision));
}
